<template>
  <el-form
    style="max-height: 400px; padding-right: 10px; overflow-x: hidden; overflow-y: auto"
    ref="formRef"
    :model="landData"
    label-width="140px"
    @submit.native.prevent
  >
    <template v-if="isBatch"></template>
    <!-- 批量更新不显示内容标签 -->

    <template v-else>
      <el-form-item label="标签内容" v-if="isUpdate">
        <el-input
          v-model.trim="landData.content"
          placeholder="标签一行一个,每个标签不超过100个字符"
          maxlength="100"
          show-word-limit
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item v-else label="标签内容">
        <template v-if="isAdd">
          <el-input
            v-model="landData.content"
            type="textarea"
            style="width: 100%"
            :autosize="{ minRows: 8, maxRows: 9 }"
            placeholder="标签一行一个,每个标签不超过100个字符"
          />
          <p class="g-error-text">注: 标签一行一个,每个标签不超过100个字符</p>

          <div v-show="rows">
            共<span class="g-error-text">{{ rows }}</span>
            个标签
          </div>
        </template>
      </el-form-item>
    </template>

    <el-form-item label="游戏组">
      <el-select
        v-model="landData.group"
        @change="handleGroup"
        :popper-append-to-body="false"
        filterable
        multiple
        clearable
        placeholder="全部"
        style="width: 100%"
      >
        <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="游戏（可多选）">
      <el-select
        v-model="landData.game"
        @change="clear"
        :popper-append-to-body="false"
        multiple
        filterable
        clearable
        placeholder="全部"
        style="width: 100%"
      >
        <el-option v-for="item in gameList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue'
import { trim, isArray } from '@/common/js/utils'
import { Message } from 'element-ui'
import { FORM_TYPE } from '../const'

// eslint-disable-next-line
const props = defineProps({
  info: Object,
  formType: { type: String, default: '' },
  groupList: Array,
  gameList: Array
})

const { proxy } = getCurrentInstance()
const route = computed(() => proxy.$route)

// State
const landData = ref({
  labelId: '',
  content: '',
  group: '',
  game: []
})
const formRef = ref(null)

// Computed
const isTagPage = computed(() => route.value.name === 'tagsindex')

const isBatch = computed(() => props.formType === FORM_TYPE.BATCH)
const isAdd = computed(() => props.formType === FORM_TYPE.ADD)
const isUpdate = computed(() => props.formType === FORM_TYPE.UPDATE)

const rows = computed(() => {
  return landData.value.content && landData.value.content.split(/\r?\n/).filter((ret) => trim(ret)).length
})

// Methods
const resetForm = () => {
  landData.value = { labelId: '', content: '', game: [], group: '' }
}

const setForm = (data) => {
  if (data) {
    // 适配传入的数据结构
    const { labelId, content, game, group } = data
    landData.value = {
      labelId: labelId || '',
      content: content || '',
      game: game || [],
      group: group || ''
    }
  }
}

const getForm = () => {
  const { labelId, content, game } = landData.value
  return {
    labelId,
    label: content, // useTags.js updateTag uses 'label'
    labels: content, // useTags.js addNewTag uses 'labels'
    gameIds: game
  }
}

const validate = () => {
  return new Promise((resolve, reject) => {
    const { content, game } = landData.value
    if (!content && !isBatch) {
      Message.error('标签内容不能为空！')
      reject(new Error('标签内容不能为空！'))
      return
    }
    if (isTagPage.value) {
      if (!isArray(game) || game.length === 0) {
        Message.error('请选择至少一个游戏！')
        reject(new Error('请选择至少一个游戏！'))
        return
      }
    }
    resolve(true)
  })
}

const handleGroup = (val) => {
  const games = []
  if (Array.isArray(val) && val.length) {
    val.forEach((ret) => {
      const index = props.groupList.findIndex((met) => met.id === ret)
      const { gameIds } = props.groupList[index]
      games.push(...gameIds.map(Number))
    })
    landData.value.game = Array.from(new Set(games))
  } else {
    landData.value.game = []
  }
}

const clear = () => {}

// Watch
watch(
  () => props.info,
  (nVal) => {
    setForm(nVal)
  },
  { deep: true, immediate: true }
)
// eslint-disable-next-line
defineExpose({
  resetForm,
  setForm,
  getForm,
  validate
})
</script>

<style lang="scss" scoped></style>
